<template>
  <div class="checkbox-group-edit-modal" v-if="showModal">
    <div class="modalHeader">
      <span class="title">Edit Checkbox Group</span>
      <span @click="closeModal" class="btn-close float-right"><i class="fas fa-times"></i></span>
    </div>

    <div class="modalBody">
      <div class="form-group">
        <label class="font14"><b>Name:</b></label>
        <input type="text" class="form-control form-control-sm" v-model="editName">
      </div>
      <div class="form-group">
        <label class="font14"><b>Label:</b></label>
        <input type="text" class="form-control form-control-sm" v-model="editLabel">
      </div>
      <div class="form-group">
        <label class="font14"><b>Help Text:</b></label>
        <textarea class="form-control form-control-sm" v-model="editHelp" />
      </div>
      <!-- <div class="form-group">
        <label>Max Checked:</label>
        <input type="number" min="1" step="1" class="form-control" v-model="editMaxChecked" />
      </div> -->

      <div class="button-box float-right">
        <button class="btn btn-success" @click="saveEdit">Save</button>
        <button class="btn btn-default" @click="closeModal">Close</button>
      </div>

      <table class="table table-sm table-bordered table-striped">
        <thead>
          <tr>
            <th>Checkbox ID</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(checkbox, index) in checkboxList" :key="index">
            <td>{{ checkbox.translations.en.label }}</td>
            <td>
              <button class="btn btn-sm btn-default" @click="editFormField(index)">Edit Form Checkbox</button>
              <button class="btn btn-sm btn-danger" @click="deleteCheckboxGroupCheck(index)">Remove</button>
              <i class="fas fa-angle-double-up" @click="move(index, true)"></i>
              <i class="fas fa-angle-double-down" @click="move(index, false)"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'checkbox-group-edit-modal',

  data () {
    return {
      fieldId: '',
      showModal: false,
      editName: '',
      editLabel: '',
      editHelp: '',
      // editMaxChecked: 1,
      checkboxList: []
    }
  },

  mounted () {
    let that = this
    this.$bus.on('checkboxGroupEditModal', function (fieldId) {
      that.fieldId = fieldId
      const storeGroup = that.$store.state.templates[that.$store.state.currentTemplateName]['chGroups'][fieldId]
      that.editName = storeGroup.name
      that.editLabel = storeGroup.title
      that.editHelp = storeGroup.desc
      // that.editMaxChecked = that.$store.getters.fieldGroupMaxFields(storeGroup.fieldId)
      that.checkboxList = JSON.parse(JSON.stringify(that.$store.getters.orderFieldGroupFields(storeGroup.checkboxes)))
      that.showModal = true
    })
  },

  methods: {
    closeModal () {
      this.showModal = false
    },

    editFormField (index) {
      this.$bus.emit('openFieldMenu', {
        id: index
      })
      this.showModal = false
    },

    deleteCheckboxGroupCheck (index) {
      this.$store.commit('deleteExistOnCheckboxGroups', index)
      this.$bus.emit('reloadQuestionnaire')
      this.$store.dispatch('saveTemplate')
      // this.$bus.emit('updateQuestionnaire')
      let list = []
      list = this.checkboxList
      Object.keys(list).forEach(id => {
        if (id === index) delete list[id]
      })

      this.checkboxList = Object.assign({}, this.checkboxList, list)
      if (Object.keys(this.checkboxList).length === 0) this.showModal = false
    },

    move (moveIndex, up) {
      let tmpContainer = {}
      let targetIndex = -1
      let keys = []
      keys = Object.keys(this.checkboxList)

      for (let index = 0; index < keys.length; index++) {
        tmpContainer[index] = keys[index]
        if (moveIndex === keys[index]) targetIndex = index
      }

      if (targetIndex === -1) return
      if (up && targetIndex - 1 < 0) return
      if (!up && targetIndex + 1 > keys.length - 1) return
      let newTarget = up ? targetIndex - 1 : targetIndex + 1

      let tmpCheckboxList = JSON.parse(JSON.stringify(this.checkboxList))

      tmpCheckboxList[moveIndex].tabOrder = tmpCheckboxList[keys[newTarget]].tabOrder
      tmpCheckboxList[keys[newTarget]].tabOrder = tmpCheckboxList[moveIndex].tabOrder

      keys.splice((newTarget < 0 ? keys.length + newTarget : newTarget), 0, keys.splice(targetIndex, 1)[0])

      let newData = {}
      for (let index = 0; index < keys.length; index++) {
        const element = keys[index]
        newData[element] = JSON.parse(JSON.stringify(tmpCheckboxList[element]))
      }

      this.checkboxList = newData

      this.$store.commit('setCheckboxGroupFields', {
        nameGroup: this.fieldId,
        checkboxes: this.checkboxList
      })

      this.$store.dispatch('saveTemplate')
    },

    saveEdit () {
      this.$store.commit('editCheckboxGroup', {
        index: this.fieldId,
        name: this.editName,
        label: this.editLabel,
        help: this.editHelp
      })

      let that = this
      window.tmpTimeout = setTimeout(function () {
        // that.$store.commit('setGroupFieldMaxChecked', {
        //   index: that.fieldId,
        //   maxChecked: Number(that.editMaxChecked)
        // })
        clearTimeout(window.tmpTimeout)
        that.$store.dispatch('saveTemplate')
        // that.$bus.emit('updateQuestionnaire')
        that.$bus.emit('reloadQuestionnaire')
      }, 1000)
      this.showModal = false
    }
  },

  beforeDestroy () {
    this.$bus.$off('checkboxGroupEditModal')
  }
}
</script>

<style lang="scss" scoped>
  .checkbox-group-edit-modal {
    position: fixed;
    top: 10%;
    left: 50%;
    margin-left: -45%;
    width: 90%;
    max-width: 1700px;
    min-height: 600px;
    max-height: 90%;
    border: 1px solid black;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #FFF;
    z-index: 100;

    .modalHeader {
      background-color: #2d5f8b;
      color: #FFF;
      font-size: 18px;
      padding: 5px 10px 5px 10px;
      height: 37px;
    }

    .btn-close {
      cursor: pointer;
      color: #FFF;
    }

    .modalBody {
      position: absolute;
      padding: 10px;
      width: 100%;
      height: calc(100% - 37px);
      overflow-y: auto;
    }
  }

  .button-box {
    float: right;
    margin-right: 30px;
    margin-bottom: 15px;
    .btn {
      margin-left: 10px;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/questionnaires/CheckboxGroupEditModal.vue